import { render, staticRenderFns } from "./Bnnner.vue?vue&type=template&id=a4c4436c&scoped=true&"
import script from "./Bnnner.vue?vue&type=script&lang=js&"
export * from "./Bnnner.vue?vue&type=script&lang=js&"
import style0 from "./Bnnner.vue?vue&type=style&index=0&id=a4c4436c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c4436c",
  null
  
)

export default component.exports